import { useController } from 'react-hook-form'
import { TextField as Input } from '@leroy-merlin-br/backyard-react'

const TextField = props => {
  const { field } = useController(props)
  const { onChange: fieldOnChange, ref } = field
  const { onChange: customOnChange, ...restProps } = props

  const handleChange = event => {
    fieldOnChange(event)

    if (customOnChange) {
      customOnChange(event)
    }
  }

  return <Input {...field} {...restProps} ref={ref} onChange={handleChange} />
}

export default TextField
